module.exports = __webpack_public_path__ + "img/order.1d4fc1f7.svg";